export const Direction = {
  BottomRight: 'bottomRight'
};
